window.addEventListener('DOMContentLoaded', function() {
  let desktopFilterDropDowns = document.querySelectorAll('.filter-desktop__dropdown');
  desktopFilterDropDowns.forEach(desktopDropdown => {
    desktopDropdown.addEventListener('click', function(e) { 
      if (e.currentTarget.classList.contains('filter-desktop__dropdown')) {
        desktopFilterDropDowns.forEach(dfd => {
          if (dfd == e.currentTarget) {
            dfd.classList.toggle('open');
          } else {
            dfd.classList.remove('open');
          }
        });
      }
    });
    document.addEventListener('click', e => {
      if (e.target.closest('.filter-desktop__dropdown') == null) {
        desktopFilterDropDowns.forEach(dfd => {
          dfd.classList.remove('open');
        });
      }
    });
  });

  let desktopDropdownValues = document.querySelectorAll('.filter-desktop__dropdown-values input');
  desktopDropdownValues.forEach(desktopDropdownValue => {
    desktopDropdownValue.addEventListener('change', e => {
      const checkboxName = desktopDropdownValue.getAttribute('name');
      const checkboxValue = desktopDropdownValue.getAttribute('value');
      document.querySelector(`.filters input[name="${checkboxName}"][value="${checkboxValue}"]`).checked = desktopDropdownValue.checked;
    });
  });

  if (document.querySelector('.filters-desktop button') != null) {
     document.querySelector('.filters-desktop button').addEventListener('click', e => {
      console.log('submit');
      document.querySelector('.filters form').submit();
    }); 
  }

  const openDawers = document.querySelectorAll('[data-action="open-drawer"]');
  openDawers.forEach(openDrawer => {
    openDrawer.addEventListener('click', function(e) {
      const drawerContent = document.querySelector(`#${e.target.getAttribute('data-drawer-id')}`);
      drawerContent.classList.toggle('open');
      drawerContent.querySelector('.drawer-close').addEventListener('click', e => {
        drawerContent.classList.remove('open');
      });
    });
  });

  document.querySelectorAll('.filter-desktop__dropdown-values input[value="Dresses"]').forEach(dressInput => {
    dressInput.addEventListener('change', function() {
      if (dressInput.checked) {
        document.querySelector('.filter-desktop__dropdown-values input[value="Maxi"]').closest('label').classList.remove('hide');
        document.querySelector('.filter-desktop__dropdown-values input[value="Mini"]').closest('label').classList.remove('hide');
        document.querySelector('.filter-desktop__dropdown-values input[value="Midi"]').closest('label').classList.remove('hide');
      } else {
        document.querySelector('.filter-desktop__dropdown-values input[value="Maxi"]').closest('label').classList.add('hide');
        document.querySelector('.filter-desktop__dropdown-values input[value="Maxi"]').checked = false;
        document.querySelector('.filter-desktop__dropdown-values input[value="Mini"]').closest('label').classList.add('hide');
        document.querySelector('.filter-desktop__dropdown-values input[value="Mini"]').checked = false;
        document.querySelector('.filter-desktop__dropdown-values input[value="Midi"]').closest('label').classList.add('hide');
        document.querySelector('.filter-desktop__dropdown-values input[value="Midi"]').checked = false;
      }
    });
  })
});

window.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.filter-label').forEach(filterLabel => {
    filterLabel.addEventListener('click', e => {
      e.target.nextElementSibling.classList.toggle('open')
    });
  });
});